// extracted by mini-css-extract-plugin
export default {"feedbackButton":"App_feedbackButton__damra"};